import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Button, Popover, Typography } from '@mui/material';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import PulsatingButton from '../../components/PulsatingButton';

interface IProps {
  isPulsating: boolean;
}

export default function FavoriteLockedIcon({ isPulsating }:IProps) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const navigate = useNavigate();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = (e:React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'warning' : undefined;

  return <>
  <PulsatingButton
      sx={{ marginBottom: '0.35em', minWidth: '2em' }}
      onClick={handleClick}
      size='small'
      isPulsating={isPulsating}
    >
       <WarningAmberIcon />
    </PulsatingButton>
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Typography variant='body1' sx={{ p: 2, maxWidth: '500px' }}>
        One of the path components has been disabled in the system. You can
        build a new path with the same components using <Button
        variant='text' onClick={() => navigate('/build-your-own')}>
        Build Your Own Path
      </Button>.
      </Typography>
    </Popover>
  </>;
}